module.exports = __webpack_public_path__ + "img/header1.69e5edfe.png";